import { render, staticRenderFns } from "./photograph.vue?vue&type=template&id=66e6b00e&scoped=true"
import script from "./photograph.vue?vue&type=script&lang=js"
export * from "./photograph.vue?vue&type=script&lang=js"
import style0 from "./photograph.vue?vue&type=style&index=0&id=66e6b00e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e6b00e",
  null
  
)

export default component.exports